import React from 'react';
interface PageIntroProps {
  eyebrow: string;
  title: string;
  lead: string;
}
export function PageIntro({
  eyebrow,
  title,
  lead
}: PageIntroProps) {
  return <header className="border-b border-ink-200 bg-paper-raised" data-id="element-30" data-mp="3czn2r2yg99ln">
      <div className="mx-auto max-w-6xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-31" data-mp="2z7p2ziqmoq25">
        <p className="text-[11px] uppercase tracking-label text-accent" data-id="element-32" data-mp="3377ks5n5kl0r">{eyebrow}</p>
        <div className="mt-5 grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-33" data-mp="3qxtib2zj6mwi">
          <h1 className="font-display text-[38px] leading-[1.08] tracking-[-0.01em] text-ink-950 sm:text-[52px]" data-id="element-34" data-mp="3qvqumplup5uy">
            {title}
          </h1>
          <p className="max-w-prose text-[17px] leading-relaxed text-ink-700 lg:pb-2" data-id="element-35" data-mp="3hvu0w9kltgt1">{lead}</p>
        </div>
      </div>
    </header>;
}